(ns web3.screens.asset
  (:require-macros [web3.build.assets :as assets])
  (:require [reagent.core :as r]
            [web3.routing.core :as routing]
            [web3.components.widgets :as widgets]
            [web3.i18n :as i]
            [web3.forms.fields :as fields]
            [web3.queries.asset :as q-asset]
            [web3.persistence.deletions :as deletions]
            [web3.persistence.schema :as schema]
            [web3.modals.alerts :as alerts]
            [web3.components.card :as card]
            [web3.components.icons :as icons]
            [web3.screens.content :as content]
            [web3.components.parent :as parent]
            [web3.utils :as utils]
            [web3.view :as v]
            [web3.modals.core]
            [web3.components.persisted :as persisted]
            [web3.tracking.components :as tracking]
            [web3.constants :as constants]
            [clojure.string :as str]
            [web3.persistence.graphql :as g]
            [web3.backend-stubs :as backend-stubs]
            [web3.routers.app-helpers :as app-route]
            [web3.icons.shapes :as shapes]
            [web3.view.hiccup :as hiccup]
            [web3.icons.asset :as asset-i]
            [web3.components.linkify :as linkify]
            [web3.log :as log]
            [re-frame-simple.db :as db]
            [shadow.lazy :as lazy]
            [web3.components.intercom :as intercom]
            [web3.env :as env]
            [web3.ui-state :as ui-state]
            ["canvas-confetti" :as confetti]
            [web3.tracking.segment :as segment]
            [web3.hints.core :as hints]
            [applied-science.js-interop :as j]))

(def intercom-show! (lazy/loadable web3.components.intercom/show!))

(def mail-icon
  [:svg
   {:width "28px", :height "20px", :view-box "0 0 28 20", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-61.000000, -102.000000)", :fill "currentColor", :fill-rule "nonzero"}
     [:g
      {:transform "translate(61.000000, 102.000000)"}
      [:path
       {:d "M28,19.2156863 L28,0.784313725 C28,0.351149216 27.6418278,0 27.2,0 L0.8,0 C0.3581722,0 0,0.351149216 0,0.784313725 L0,19.2156863 C0,19.6488508 0.3581722,20 0.8,20 L27.2,20 C27.6418278,20 28,19.6488508 28,19.2156863 Z M26.75,1 L14,10.5 L1.25,1 L26.75,1 Z M1,18.9917114 L1,2 L13.4925806,11.3620185 C13.7924838,11.5872203 14.2075162,11.5872203 14.5074194,11.3620185 L27,2.00828864 L27,19 L1,18.9917114 Z"}]]]]])

(defn delete-asset [asset]
  (let [name (schema/asset-display-name asset)]
    (deletions/delete-with-confirm
      (merge asset
             {:text-primary
              (i/get :asset/delete.primary {:name name})

              :confirm
              {:text-primary
               (i/get :asset/delete.confirm-contents.primary {:name name})
               :text-secondary
               #(some->> (->> (q-asset/asset-contents {:id (:id asset)})
                              :entity
                              :contents)
                         (keep schema/entity-display-name)
                         (seq)
                         (i/parse-collection)
                         (i/get :asset/delete.confirm-contents.secondary))}
              :on-complete (partial deletions/close-deleted-entity-modal! (:id asset))
              :mutate!
              (fn [opts]
                (q-asset/asset-delete!
                  {:id (:id asset)}
                  (assoc opts
                    :refetch [q-asset/asset-group*])))
              :snack
              (i/get :asset/delete-complete)}))))

(defn filter-recalls [r]
  (->> r
       (filter (comp #{"notified"} :status))
       (seq)))

(v/defview asset-recall-respond
  [{:keys [recall-id]}]
  (let [this (r/current-component)
        close! #(alerts/drop-frames 1)
        recall-response! (fn [code]
                           (q-asset/recall-status-update!
                             {:id recall-id
                              :code code}
                             {:component this
                              :on-complete close!}))
        recall-codes {:recall/resolved 'confirmed
                      :recall/rejected 'rejected
                      :recall/dismissed 'dismissed}]
    [alerts/alert-view
     {:text-primary (i/get :recall/did-apply?)
      :text-secondary (i/get :recall/did-apply?.detail)
      :mutation-state (g/mutation-state)
      :buttons (-> (for [[key code] (seq recall-codes)]
                     {:on-click (partial recall-response! code)
                      :label (i/get key)
                      :style {:border-top "1px solid white"}})
                   (vec)
                   (conj {:on-click close!
                          :label (i/get :i/cancel)
                          :class "pad-v-3"
                          :style {:border-top "1px solid white"}}))}]))

(defn alert-status-processing-icon
  ([] (alert-status-processing-icon nil))
  ([processing-time]
   [:div.text-dark-gray
    asset-i/processing
    [:div.pre-wrap.text-size-10.margin-top-1.line-h-12
     (i/get :i/processing)
     (when processing-time
       [:<>
        [:br]
        processing-time])]]))

(def alert-status-badge
  {:processing nil
   :errored (-> asset-i/badge-question
                (hiccup/styles {:color (:yellow constants/colors)}))
   :recalled (-> asset-i/badge-exclamation
                 (hiccup/styles {:color (:red constants/colors)}))})

(defn asset-card-props
  [{:keys [manufacturer alertStatus primaryImage thumbnailImage id editable? recalls edit?] :as asset
    :or {editable? true}}]
  (let [props {:key id
               :label (schema/asset-display-name asset)
               :sub-label manufacturer
               :media-divider? true}
        processing-time (-> (q-asset/system-status)
                            :systemStatus
                            :message
                            (or "24-48 Hrs."))
        recalls (filter-recalls recalls)
        icon (when-not primaryImage
               (some-> (backend-stubs/asset-tag->icon-name (get-in asset [:tag :id]))
                       (icons/get)
                       (hiccup/styles {:height 45})))]
    (merge
      props
      (if (and editable? edit?)
        {:on-delete (partial delete-asset asset)}
        {:href (app-route/details-href asset)})
      (cond (= alertStatus
               "processing") {:icon [alert-status-processing-icon processing-time]}
            icon {:icon icon}
            :else {:image (:link (or thumbnailImage primaryImage))})
      (when-let [badge (case alertStatus
                         "processing" nil
                         "errored" (alert-status-badge :errored)
                         (when recalls
                           (alert-status-badge :recalled)))]
        {:badge [:div.round-100p.inline-block.bg-white.line-h-8
                 badge]}))))

(defn- make-confetti-props
  [ele]
  (let [{:window/keys [inner-width inner-height]} @ui-state/ui-globals
        {:keys [left #_right top #_bottom width #_height]
         #_#_:as client-rect} (some-> ele
                                      (j/call :getBoundingClientRect)
                                      j/lookup)
        _ (log/info {:left left :top top :width width})
        confetti-props #js{:particleCount 100
                           :decay 0.88
                           :spread 80
                           :ticks 100
                           :origin #js{:x (/ (+ left (/ width 2))
                                             inner-width)
                                       :y (/ top inner-height)}}]
    confetti-props))

(v/defview asset-header
  {:component-did-mount #(do
                           (hints/activate-hint-mode!)
                           (hints/show! [:hints/asset.did-we-get-it-right]))}

  [state {:as entity
          :keys [id sample parent model]
          {image-source :link} :primaryImage}]
  (let [this (r/current-component)
        editable? (not sample)
        edit-korks [:edit id]
        edit? (if-not editable?
                false
                (routing/get-query edit-korks))
        asset-mutation (fn [key component value opts]
                         (q-asset/asset-update!
                          (-> entity
                              (assoc (utils/simplify-keyword key) value))
                          (merge {:component component 
                                  ;;TODO Follow up on refetch not working here
                                  :on-complete
                                             (fn [e]
                                               (println "Completed Successfully" e)
                                               )
                                  :refetch [q-asset/asset-group*]
                                  }
                                 
                                 opts)))
        field-props (fn [key]
                      {:persist-value! (partial asset-mutation key)
                       :persisted-value (get entity (utils/simplify-keyword key))})
        {:keys [alertStatus]} entity
        field-header :div.text-uppercase.text-dark-gray.text-size-10
        field-value :div.text-uppercase.text-black.text-size-13
        field-value-link :a.text-uppercase.text-blue.text-size-13]
    [:div.flex.flex-column.pre-wrap.bg-white
     [:div.flex.items-stretch.flex-column-mobile.pad-h-2.margin-top-2
      [:div.modal-header-image.flex-none.margin-all-2.flex.justify-center
       (cond
         (and edit? (nil? image-source))
         [persisted/file-upload {:style {:cursor "pointer"}
                                 :change-value! #(q-asset/content-create! {:contentedId (:id entity)
                                                                           :curated false
                                                                           :title (str (utils/format-date (.now js/Date))
                                                                                       " "
                                                                                       (schema/asset-display-name entity))
                                                                           :link %
                                                                           :data-allowed-file-extensions
                                                                           (get schema/dropify-file-exts "image")
                                                                           :category "image"}
                                                                          {:component this
                                                                           :refetch [q-asset/asset-contents]})}]
         image-source {:style {:background-image (str "url(" image-source ")")
                               :height (when image-source 250)}})
       (when (and (not image-source)
                  (not edit?))
         (some-> (backend-stubs/asset-tag->icon-name (get-in entity [:tag :id]))
                 (icons/get)
                 (hiccup/styles {:height 100
                                 :margin-top 30})))]

      [:div.flex.flex-column.margin-h-2..margin-top-2.overflow-hidden.flex-auto
       #_{:style {:flex-basis "66%"}}
       [:div.flex.items-start.flex-wrap
        [:div.text-size-26.weight-semi-bold.flex.items-center.flex-auto.pad-bottom-2
         (if edit?
           (fields/from-schema :Asset/nickname
                               (-> (field-props :Asset/nickname)
                                   (assoc-in [:container :style :min-width] 200)))
           (schema/asset-display-name entity))
         (when editable?
           [widgets/edit-pencil-drawer edit-korks])]
        (when-let [find-a-pro-link (and (not edit?)
                                        (schema/find-a-pro-link entity))]
          [widgets/black-button {:href find-a-pro-link
                                 :class "inline-flex"
                                 :style {:margin-right 30}
                                 :target "_blank"
                                 :rel "noopener"} (i/get :drawer/need-help.label)])]
       (doall (for [key [:Asset/tagName
                         :Asset/manufacturer
                         :Asset/modelNumber
                         :Asset/serialNumber]
                    :let [value (get entity (utils/simplify-keyword key))]
                    :when (or edit? value)]
                (if edit?
                  (fields/from-schema
                    key
                    (field-props key))
                  [:div.margin-v-2.line-h-18
                   {:key (str key "-readonly")}
                   [field-header
                    (i/get (if (= key :Asset/tagName)
                             ;; Asset/tagName is called "type" in read-only mode
                             :i/type
                             key))]
                   [field-value
                    value]])))

       (when-not edit?
         (when-let [{:keys [manufacturerSupportPhone
                            manufacturerSupportWebsite]} model]
           [:div
            (when manufacturerSupportPhone [:div.margin-v-2.line-h-18
                                            [field-header (i/to-do "Support")]
                                            [field-value-link
                                             {:href (str "tel:" manufacturerSupportPhone)}
                                             manufacturerSupportPhone]])

            (when manufacturerSupportWebsite [:div.margin-v-2.line-h-18
                                              [field-header (i/to-do "Website")]
                                              [field-value
                                               [linkify/linkify (utils/strip-www manufacturerSupportWebsite)]]])]))

       (when parent
         [:div.margin-v-2.line-h-18
          (if edit?
            (fields/from-schema
              :Asset/assetGroupId
              (assoc (field-props :Asset/assetGroupId)
                ;; we mutate `assetGroupId`, but in queries we read `parent.id`
                :persisted-value (get-in entity [:parent :id])
                :on-save (partial asset-mutation :Asset/assetGroupId this)))
            [:a.hover-text-real-black
             {:href (app-route/parent-href parent)}
             [field-header
              (parent/parent-type (:id parent))]
             [field-value
              (parent/parent-name (:id parent))]])])
       (when-not (or (:sample entity)
                     alertStatus)
        (let [vote (db/get-in [::did-we-get-it-right (:id entity) :vote])
              event-name "\"Did we get it\" vote"
              show-intercom-message! #(intercom/show!
                                       (i/get %
                                              (merge
                                               {:partnerName (:partner/name env/config)
                                                :domain utils/domain}
                                               (select-keys entity
                                                            [:tagName
                                                             :manufacturer
                                                             :modelNumber]))))]
          [:div.pad-v-2.flex.justify-between
           {:style {:max-width "325px"}}
           [:div
            {:style {:margin-top "auto"
                     :margin-bottom "auto"}}
            "Did we get it right?"]
           (if-not (= :up vote)
             [:div#confetti-anchor.cursor-pointer
              {:on-click (fn []
                           (confetti (make-confetti-props (utils/get-element "#confetti-anchor")))
                           (when-not (= vote :up)
                             (segment/event! event-name {:vote "up"
                                                         :chat-requested false})
                             (db/assoc-in! [::did-we-get-it-right (:id entity) :vote] :up)))}
              (icons/get :thumbup)]
             [:div#confetti-anchor.cursor-pointer
              {:on-click #(confetti (make-confetti-props (utils/get-element "#confetti-anchor")))}
              (icons/get :thumbup-voted)])

           (if-not (= :down vote)
             [:div.cursor-pointer
              {:on-click #(when-not (= vote :down)
                            (show-intercom-message! :did-we-get-it-right/thumbs-down.inquiry)
                            (segment/event! event-name {:vote "down"
                                                        :chat-requested false})
                            (db/assoc-in! [::did-we-get-it-right (:id entity) :vote] :down))}
              (icons/get :thumbdown)]
             [:div.cursor-pointer
              {:on-click #(show-intercom-message! :did-we-get-it-right/thumbs-down.inquiry)}
              (icons/get :thumbdown-voted)])
           [:div.cursor-pointer
            {:on-click #(do (segment/event! event-name {:vote "none"
                                                        :chat-requested true})
                            (show-intercom-message! :did-we-get-it-right/chat.inquiry))}
            (icons/get :chatbubble)]
           [:div#did-we-get-it-right-info-bubble.cursor-pointer
            {:on-click #(js/setTimeout (fn []
                                         (hints/force-show! [:hints/asset.did-we-get-it-right]))
                                       10)}
            (icons/get :infbubble)]]))
       (when edit?
         [:div
          [widgets/primary-button
           {:on-click #(delete-asset entity)
            :class "border-gray margin-bottom-3"}
           (i/get :i/delete)]
          [widgets/black-button
           {:on-click #(routing/set-query! edit-korks nil)
            :class "margin-bottom-3"}
           (i/get :i/done)]])]]]))

(def section-title :div.text-size-17.line-h-22.weight-medium.pad-h-2.margin-v-3.flex.items-center)
(defn divider []
  [:div.margin-top-3.margin-h-2.modal-divider
   {:key (rand-int 1000000)}])

(defn asset-alert-status [{:as asset
                           :keys [recalls
                                  alertStatus
                                  tag
                                  tagName]}]
  (when-let [{:keys [bg-color
                     color
                     icon
                     title
                     detail
                     action]
              :or {color "black"}}
             (let [system-status (or (-> (q-asset/system-status)
                                         :systemStatus
                                         :message)
                                     "24-48")
                   tag-name (or tagName
                                (some-> (:name tag)
                                        (str/lower-case))
                                "Item")]
               (case alertStatus
                 "processing"
                 {:bg-color (:alert-blue constants/colors)
                  :icon asset-i/processing
                  :title (i/get :asset/alert-status.processing.title {:tagName tag-name})
                  :detail (i/get :asset/alert-status.processing.detail {:processingTimeframe system-status})}
                 "errored"
                 {:bg-color (:alert-yellow constants/colors)
                  :icon asset-i/badge-question
                  :title (i/get :asset/alert-status.errored.title)
                  :detail (i/get :asset/alert-status.errored.detail)
                  :action [:div
                           [widgets/black-button
                            {:class "block"
                             :href (routing/path-for :router/form-modal [:asset/clarify :asset-id (:id asset)])}
                            (i/get :i/clarify)]]}
                 (when-let [recalls (filter-recalls recalls)]
                   {:bg-color "#000000"
                    :color "white"
                    :icon (-> asset-i/badge-exclamation
                              (hiccup/styles {:color (:red constants/colors)}))
                    :title (i/get :asset/alert-status.recalled.title {:tagName tag-name})
                    :detail (:title (first recalls))
                    :action [:div.flex
                             [widgets/primary-button {:href (:url (first recalls))
                                                      :target "_blank"
                                                      :rel "noopener"
                                                      :class "bg-white text-black hover-bg-off-white margin-right-2"}
                              (i/get :i/take-action)]
                             [widgets/primary-button {:on-click #(alerts/add-frame [asset-recall-respond {:recall-id (:id (first recalls))}])
                                                      :class "text-white border-gray hover-bg-black"}
                              (i/get :i/dismiss)]]})))]
    [:div.pad-v-3.pad-h-3.flex.items-start.flex-column-mobile
     {:style {:background-color bg-color
              :color color}}
     [:div.margin-all-2.flex-auto.flex
      [:div.margin-right-2 (hiccup/size icon 32)]
      [:div
       [:div.text-size-26.weight-semi-bold.margin-bottom-2
        title]
       [:div.text-size-16.line-h-20
        {:style {:max-width 600}}
        detail]]]
     [:div.margin-all-2.flex.items-end.text-align-right action]]))

(v/defview collapsible-curated-grid
  {:component-did-mount (fn [{:keys [props state]}]
                          (let [{:keys [alertStatus]} props]
                            (when (= "processing" alertStatus)
                              (reset! state {:collapsed? true}))))

   :component-will-receive-props (fn [{:keys [state] :as this} props]
                                   (let [passed-grid-props (nth props 2)
                                         {:keys [cards]} passed-grid-props]
                                     (when (and (nil? @state)
                                                (empty? cards))
                                       (reset! state {:collapsed? true}))))}

  [entity {:keys [label cards not-found-key not-found-label]}]
  (let [{:keys [state]} (r/current-component)
        {:keys [collapsed?]} @state
        processing? (= (:alertStatus entity)
                       "processing")]
    [:div
     [section-title
      {:key label
       :class "cursor-pointer hover-opacity-parent"
       :on-click #(swap! state update :collapsed? not)}
      [:div.inline-block.pad-left-2.pad-right-3
       (-> (if collapsed?
             shapes/chevron-down
             shapes/chevron-up)
           (hiccup/class "hover-opacity-child"))]
      label
      (when-not processing?
        (utils/coll-count 20 cards))]
     (when-not collapsed?
       [card/card-grid
        (assoc card/curated-grid-props
          :key (str label "-grid")
          :class "margin-bottom-3")
        (if processing?
          [{:key "processing"
            :icon asset-i/processing
            :card-style :dashed-gray
            :class "opacity-60"
            :label (i/get :i/processing)}]
          (cond-> (if (empty? cards)
                    [{:key "not-found"
                      :icon (icons/get not-found-key)
                      :card-style :dashed-gray
                      :class "opacity-60"
                      :label (i/get not-found-key)}]
                    (vec cards))
                  (lazy/ready? intercom-show!)
                  (conj {:key "not-found/ask"
                         :wrap? true
                         :media-height "100%"
                         :on-click #(@intercom-show!
                                     (i/get (keyword (namespace not-found-key)
                                                     (str (name not-found-key) ".inquiry"))
                                            (merge
                                             {:partnerName (:partner/name env/config)
                                              :missingType
                                              (if not-found-label
                                                not-found-label
                                                not-found-key)}
                                             (select-keys entity
                                                          [:tagName
                                                           :manufacturer
                                                           :modelNumber]))))

                         :media [:div.text-size-14.pad-all-2
                                 (i/get :not-found/ask)
                                 [:div.margin-top-2 mail-icon]]})))])]))

(v/defview asset-page
  {:component-did-mount #(let [[_ entity] (:argv %)]
                           (tracking/assoc-in-context! ::current-asset entity))
   :component-will-unmount #(tracking/dissoc-from-context! ::current-asset)}
  [entity]
  (let [{:keys [state] :as component} (r/current-component)
        {encompass-count :productCount
         encompass-link :modelPageLink} (get-in entity [:model :encompassData])
        {{user-contents :contents
          curated-contents :contentsCurated
          {products :products} :model} :entity
         content-loading? :graphql/loading?} (when-let [id (:id entity)]
                                               (q-asset/asset-contents {:id id}))
        {how-to true
         manuals false} (->> curated-contents
                             (filter (comp #{"document" "note" "video"} :category))
                             (group-by (comp (partial = "video") :category)))
        {:keys [edit?]
         :or {edit? false}} @state]
    [:div.flex.flex-column.pre-wrap
     [asset-alert-status entity]
     [asset-header state entity]
     [:div.modal-divider]
     (into [:div.bg-off-white.pad-h-2]
           (->> [{:label (i/get :asset/products)
                  :cards (concat
                          (for [{:as product
                                 :keys [primaryImage thumbnailImage]
                                 label :name} products]
                            (merge product
                                   {:label label
                                    :label-lines 2
                                    :label-size 13
                                    :media-divider? true
                                    :expanded-view content/product-details}
                                   (if-let [image (:link (or thumbnailImage primaryImage))]
                                     {:image image}
                                     {:icon asset-i/product})))
                          (when (and (pos? encompass-count)
                                     encompass-link
                                     constants/encompass-service-is-enabled?)
                           [{:label (i/to-do (str "View all " encompass-count " items"))
                             :image (assets/with-hash "/images/card-encompass-rectangle@3x.png")
                             :href encompass-link
                             :large? true
                             :curated true
                             :media-divider? true
                             :label-inverted true
                             :image-fit "cover"
                             :mediaType "text/html"
                             :icon asset-i/product}]))
                  :not-found-key :not-found/products}

                 ;; Manuals & Guides
                 {:label (i/get :files/manuals)
                  :cards (->> manuals
                              (mapv #(content/content-card (assoc % :edit? edit?
                                                                    :large? true
                                                                    :href (:link %)
                                                                    :expanded-view content/content-details))))
                  :not-found-key :not-found/manuals}

                 {:label (i/get :content/how-tos)
                  :cards (->> how-to
                              (mapv #(content/content-card (assoc % :edit? edit?
                                                                    :large? true
                                                                    :expanded-view content/content-details))))
                  :not-found-key :not-found/videos}]

                (mapv (fn [x]
                        [collapsible-curated-grid entity x]))
                (interpose divider)))
     [:div.bg-white.modal-rounded-bottom
      (when-not content-loading?
        [content/user-contents-by-category
         {:contents user-contents
          :edit? edit?
          :label-prefix (i/get :i/my)
          :collapse-empty? true
          :editable? (not (:sample entity))
          :dividers? true
          :expand-inline? true
          :add-query (parent/modal-query-data {:mutable? false
                                               :root (:id entity)
                                               :root-type "Asset"})}])]]))
